<template>
    <section v-if="!loadash.isEmpty(reportStore.getAccountDetail(account).payment_history)" class="table-responsive">
        <div class="d-sm-flex align-items-center mb-1">
            <h4>
                Two-Year Payment History
                <small
                    v-if="reportStore.isViolation(account, 0, 'payment_history', 'payment_history').isViolation"
                    class="text-danger"
                    :id="`violation-payment-history-${account[0].id}`"
                >
                    Violation
                    <b-popover
                        :target="`violation-payment-history-${account[0].id}`"
                        placement="top"
                        triggers="hover"
                        :html="true"
                    >
                        <template #title>Violation</template>
                        <div class="row">
                            <div class="col-12">
                                <p>
                                    {{ reportStore.isViolation(account, 0, 'payment_history', 'payment_history').message }}
                                </p>
                            </div>
                        </div>
                    </b-popover>
                </small>
            </h4>
            <b-popover
                :target="`legend-${accountType}-${reportStore.getAccountDetail(account).id}`"
                placement="top"
                triggers="hover"
                :html="true"
            >
                <template #title>Legend</template>
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <p>OK: Current</p>
                        <p>U: Unknown</p>
                        <p>"": No Data Provided</p>
                        <p>30: 30 Days Late</p>
                        <p>60: 60 Days Late</p>
                        <p>90: 90 Days Late</p>
                        <p>120: 120 Days Late</p>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <p>150: 150 Days Late</p>
                        <p>180: 180 Days Late</p>
                        <p>CO: Chargeoff or Collection</p>
                        <p>RF: Repossession or Foreclosure</p>
                        <p>PP: Payment Plan</p>
                        <p>VS: Voluntary Surrender</p>
                    </div>
                    <div class="col-12">
                        <p>* Sometimes the credit bureaus do not have information from a particular month on file.</p>
                    </div>
                </div>
            </b-popover>
            <button
                :id="`legend-${accountType}-${reportStore.getAccountDetail(account).id}`"
                class="btn btn-sm ml-1 btn-primary waves-effect waves-light"
            >
                Legend
            </button>
            <small class="text-danger ml-auto">* SmartCredit Sometimes Reports An Account more than one-time during the month</small>
        </div>
        <div
            v-if="
                reportStore.getAccountDetail(account).type == reportStore.smartcredit
                ||
                reportStore.getAccountDetail(account).type == reportStore.creditfixrrreports
            "
        >
            <div class="table-responsive">
                <table class="table table-success table-striped table-hover mb-0">
                    <thead class="thead-primary">
                        <tr>
                            <th>
                                Month
                            </th>
                            <th v-for="date in getDates(account)">
                                {{ reportStore.months[moment(date,"YYYY-MM-DD").month()] }}
                            </th>
                        </tr>
                    </thead>
                    <tbody class="table-striped">
                        <tr>
                            <td>
                                Year
                            </td>
                            <td v-for="date in getDates(account)">
                                {{ moment(date,"YYYY-MM-DD").year() }}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                TransUnion
                            </td>
                            <td v-for="date in getDates(account)">
                                {{ reportStore.getStatus(getPaymentHistory(account[0], date), account[0].type) }}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Experian
                            </td>
                            <td v-for="date in getDates(account)">
                                {{ reportStore.getStatus(getPaymentHistory(account[1], date), account[1].type) }}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Equifax
                            </td>
                            <td v-for="date in getDates(account)">
                                {{ reportStore.getStatus(getPaymentHistory(account[2], date), account[2].type) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- <h5>TransUnion</h5>
            <div class="table-responsive">
                <table class="table table-success table-striped table-hover mb-0">
                    <thead class="thead-primary">
                        <tr>
                            <th>
                                Month
                            </th>
                            <th v-for="payStatus in account[0].payment_history.MonthlyPayStatus">
                                {{ reportStore.months[moment(payStatus.date,"YYYY-MM-DD").month()] }}
                            </th>
                        </tr>
                    </thead>
                    <tbody class="table-striped">
                        <tr>
                            <td>
                                Year
                            </td>
                            <td v-for="payStatus in account[0].payment_history.MonthlyPayStatus">
                                {{ moment(payStatus.date,"YYYY-MM-DD").year() }}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                TransUnion
                            </td>
                            <td v-for="payStatus in account[0].payment_history.MonthlyPayStatus">
                                {{ reportStore.getStatus(payStatus.status, reportStore.smartcredit) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5>Experian</h5>
            <div class="table-responsive">
                <table class="table table-success table-striped table-hover mb-0">
                    <thead class="thead-primary">
                        <tr>
                            <th>
                                Month
                            </th>
                            <th v-for="payStatus in account[1].payment_history.MonthlyPayStatus">
                                {{ reportStore.months[moment(payStatus.date,"YYYY-MM-DD").month()] }}
                            </th>
                        </tr>
                    </thead>
                    <tbody class="table-striped">
                        <tr>
                            <td>
                                Year
                            </td>
                            <td v-for="payStatus in account[1].payment_history.MonthlyPayStatus">
                                {{ moment(payStatus.date,"YYYY-MM-DD").year() }}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Experian
                            </td>
                            <td v-for="payStatus in account[1].payment_history.MonthlyPayStatus">
                                {{ reportStore.getStatus(payStatus.status, reportStore.smartcredit) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5>Equifax</h5>
            <div class="table-responsive">
                <table class="table table-success table-striped table-hover mb-0">
                    <thead class="thead-primary">
                        <tr>
                            <th>
                                Month
                            </th>
                            <th v-for="payStatus in account[2].payment_history.MonthlyPayStatus">
                                {{ reportStore.months[moment(payStatus.date,"YYYY-MM-DD").month()] }}
                            </th>
                        </tr>
                    </thead>
                    <tbody class="table-striped">
                        <tr>
                            <td>
                                Year
                            </td>
                            <td v-for="payStatus in account[2].payment_history.MonthlyPayStatus">
                                {{ moment(payStatus.date,"YYYY-MM-DD").year() }}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Equifax
                            </td>
                            <td v-for="payStatus in account[2].payment_history.MonthlyPayStatus">
                                {{ reportStore.getStatus(payStatus.status, reportStore.smartcredit) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div> -->
        </div>
        <div v-else class="table-responsive">
            <table class="table table-success table-striped table-hover mb-0">
                <thead class="thead-primary">
                    <tr>
                        <th>
                            Month
                        </th>
                        <th v-for="month in reportStore.getAccountDetail(account).payment_history.Month">
                            {{ month }}
                        </th>
                    </tr>
                </thead>
                <tbody class="table-striped">
                    <tr>
                        <td>
                            Year
                        </td>
                        <td v-for="year in reportStore.getAccountDetail(account).payment_history.Year">
                            {{ year }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            TransUnion
                        </td>
                        <td v-for="transunion in reportStore.getAccountDetail(account).payment_history.TransUnion">
                            {{ transunion }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Experian
                        </td>
                        <td v-for="experian in reportStore.getAccountDetail(account).payment_history.Experian">
                            {{ experian }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Equifax
                        </td>
                        <td v-for="equifax in reportStore.getAccountDetail(account).payment_history.Equifax">
                            {{ equifax }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>
<style>
    .popover {
        max-width: 500px;
    }
</style>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { BPopover, BButton } from 'bootstrap-vue-3'
    import moment from 'moment';
    export default {
        props: {
            account: {
                type: [Array, Object]
            },
            accountType: String
        },
        mounted() {
        },
        components: {
            BPopover,
            BButton
        },
        setup(props) {
            return {
                reportStore: useReportStore(),
                moment: moment,
                loadash: _
            }
        },
        methods: {
            getDates(account) {
                let account0 = account[0].payment_history ? _.map(account[0].payment_history.MonthlyPayStatus, 'date') : [],
                    account1 = account[1].payment_history ? _.map(account[1].payment_history.MonthlyPayStatus, 'date') : [],
                    account2 = account[2].payment_history ? _.map(account[2].payment_history.MonthlyPayStatus, 'date') : [];
                let dates = _.union(account0, account1, account2);
                return _.orderBy(dates, [], ['asc']);
            },
            getPaymentHistory(account, date) {
                if (account.payment_history) {
                    let monthlyPayStatus = _.find(account.payment_history.MonthlyPayStatus, { 'date': date });
                    if (!!monthlyPayStatus) {
                        return monthlyPayStatus.status;
                    }
                    return '--';
                }
                return 'NO DATA';
            }
        }
    }
</script>
